import React, { useEffect } from "react";
import CeoImg from "../assests/CeoImg.png";
import companiesImg from "../assests/companiesImg.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";

export default function Header() {
  const navigate = useNavigate("");
  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };
  const handleGetInTouchTwo = () => {
    navigate("/startappling");
  };
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 500,
    });
  }, []);
  return (
    <div className="headerMain" id="home">
      <div className="headerMainContainer1">
        <div className="headerMainContainer1Inner text-left">
          {/* Title */}
          <h1 className="text-3xl md:text-4xl text-white font-bold">
            Zulqarnain Mahmood
          </h1>

          {/* Subtitle */}
          <p className="text-lg md:text-xl mt-2 text-white font-medium">
            BUSINESSMAN, PROPERTY CONSULTANT, JOINT VENTURE
          </p>

          {/* Role */}
          <h2 className="text-2xl font-semibold mt-6 text-white">
            Founder and CEO
          </h2>
          <p className="text-xs sm:text-sm  mt-2 text-white font-medium">
            JV Lands & Ze Land Group of Companies
          </p>

          {/* Description */}
          {/* <p className="mt-4 text-black leading-relaxed">
            <span className="text-red-500 font-bold">"</span>
             In 1996, my journey in the real estate industry began with a small office. Over the experience of two years, by 1998, I expanded my venture, establishing 3 to 4 more offices. However, I eventually took a break to reflect on the path ahead. During this time, I gained valuable experience, and the unwavering support of my father and the constant presence of my younger brother by my side were instrumental. My father advised me to sell the property I owned at that time, and it marked a pivotal moment in my life. To pursue something bigger, we took a significant risk - we sold our own house and relocated to a rental property. With determination, I resumed my real estate journey, focusing on property buying and selling. Eventually, the day of triumph arrived when I initiated my first project in Lahore, a housing colony named GLG-I. The success of GLG-I paved the way for subsequent projects, including GLG-II, IDEAL AVENUE, and GALAXY AVENUE, all of which stand as testaments to our dedication and hard work.
            <span className="text-red-500 font-bold">"</span>
          </p> */}

          {/* Button */}
          <button
            onClick={handleGetInTouch}
            className="firstSectionChild1Button "
          >
            LET'S TALK
          </button>

          {/* <div data-aos="fade-up" className="headerMainChild1">
            <div className="jobSeekerImg">
              <p className="bg-zinc-900 w-24  lg:w-36 text-center content-center -rotate-[22deg] h-10 text-white text-sm lg:text-base">
                Job seeker
              </p>
            </div>

            <h1 className="headerMainChild1Head ">
              We help candidates find their perfect job
            </h1>
            <p className="headerMainChild1Para">
              best company to work for, we help you realize your full potential.
            </p>

            <button
              onClick={handleGetInTouchTwo}
              className="headerMainChild1Button"
            >
              Start Applying
            </button>
          </div> */}
        </div>
      </div>
      <div className="headerMainContainer2 relative">
        {/* Existing Content */}
        {/* <div data-aos="fade-up" className="headerMainChild2">
          <div className="companiesImg">
            <p className="bg-[#f6cf0b] w-24 lg:w-36 text-center content-center rotate-[23deg] h-10 text-[#18181B] text-sm lg:text-base">
              Companies
            </p>
          </div>
          <h1 className="headerMainChild2Head">
            We provide staffing solution to our clients.
          </h1>
          <p className="headerMainChild2Para">
            The most comprehensive and innovative HR business partner, focused
            on your differentiation and growth.
          </p>
          <button onClick={handleGetInTouch} className="headerMainChild2Button">
            View services
          </button>
        </div> */}
      </div>
    </div>
  );
}
